const DEFAULT_DESCRIPTION =
  "Talkpal is an AI-powered web and mobile platform that provides businesses with engaging language learning experiences across multiple languages for teams.";

export const PAGE_DESCRIPTIONS: Record<string, string> = {
  "/": DEFAULT_DESCRIPTION,
  "/signup":
    "Create a Talkpal Business account to provide your organization with AI-powered language training. Sign up today to start improving your team's communication.",
  "/login":
    "Log in to your Talkpal Business account to access AI-powered language training. Connect with your team, track learning progress, and improve communication.",
};

export const getPageMeta = (pathname: string) => {
  const normalized =
    pathname.length > 1 && pathname.endsWith("/")
      ? pathname.slice(0, -1)
      : pathname;

  return {
    description: PAGE_DESCRIPTIONS[normalized] ?? DEFAULT_DESCRIPTION,
  };
};
